import React, { useState } from 'react'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import { Permitted, MenuButton, ActiveStatusChip } from 'components'

import {
  ChangeStatusSubCategoryButton,
  RegisterResponsiblesDialog,
} from './components'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import * as service from 'service'
import constants from 'constants/index'
import theme from 'theme'

const SubCategoryTable = ({ categoryId, isCustomizable }) => {
  const [selectedSubCategory, setSelectedSubCategory] = useState(null)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { page, perPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.complaintSubCategories.get,
    { categoryId, page, perPage },
    [categoryId, page, perPage],
  )

  const subCategories = response?.data?.complaintSubCategories || []
  const totalCount = response?.data?.meta?.totalCount || 0

  const emptyMessage = isCustomizable
    ? 'Categorias customizáveis não possuem opções predefinidas'
    : 'Nenhuma opção cadastrada'

  return (
    <>
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table emptyMessage={emptyMessage} isLoading={isLoading} noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="25%">Nome</TableCell>
              <TableCell width="40%">Responsáveis</TableCell>
              <TableCell width="15%" align="center">
                Status
              </TableCell>
              <TableCell width="20%" align="center">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subCategories.map((subCategory) => {
              return (
                <TableRow key={subCategory.id}>
                  <TableCell width="25%">
                    <Box fontWeight="medium">{subCategory.name}</Box>
                  </TableCell>
                  <TableCell width="40%">
                    <Box
                      maxHeight="60px"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {subCategory.responsibles &&
                      subCategory.responsibles.length > 0
                        ? subCategory.responsibles
                            .map((responsible) => responsible.name)
                            .join(', ')
                        : '-'}
                    </Box>
                  </TableCell>
                  <TableCell width="15%" align="center">
                    <ActiveStatusChip active={subCategory.active !== false} />
                  </TableCell>
                  <TableCell width="20%" align="center">
                    <Permitted
                      someTags={[
                        constants.permissions.COMPLAINTS.MANAGE_CONFIGURATIONS,
                        constants.permissions.COMPLAINTS.ACTIVATE_COMPLAINTS,
                      ]}
                    >
                      <MenuButton>
                        <Button
                          color="secondary"
                          fullWidth
                          size="small"
                          onClick={() => setSelectedSubCategory(subCategory)}
                        >
                          Registrar Responsáveis
                        </Button>
                        <ChangeStatusSubCategoryButton
                          subCategory={subCategory}
                          categoryId={categoryId}
                          onRefresh={refresh}
                        />
                      </MenuButton>
                    </Permitted>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </PerfectScrollbar>

      {totalCount > 0 && (
        <Box p={2} display="flex" justifyContent="flex-end">
          <TablePagination
            component="div"
            count={totalCount}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      )}
      {selectedSubCategory && (
        <RegisterResponsiblesDialog
          open={!!selectedSubCategory}
          onClose={() => setSelectedSubCategory(null)}
          subCategory={selectedSubCategory}
          categoryId={categoryId}
          onRefresh={refresh}
        />
      )}
    </>
  )
}

SubCategoryTable.propTypes = {
  categoryId: PropTypes.string.isRequired,
  isCustomizable: PropTypes.bool,
}

export default SubCategoryTable
